import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Session, States } from '../services/index';

@Component({
    selector: 'signup-patient',
    templateUrl: 'signup-patient.html'
})
export class SignupPatient {
  birthdayFormGroup: FormGroup;
  patientFormGroup: FormGroup;
      
  constructor(private fb: FormBuilder,
              private router: Router,
              public session: Session,
              public states: States) {    
    this.birthdayFormGroup = this.fb.group({
      'month': new FormControl('', Validators.required),
      'day': new FormControl('', Validators.required),
      'year': new FormControl('', Validators.required)
    }, {
      validator: this.dateValidator // your validation method
    });
  
   
      console.log('signup-patient.userId: ',this.session.patient.userId );
   

    this.patientFormGroup = this.fb.group({
      'gender': new FormControl(this.session.patient.profile.gender, Validators.required),
      'firstName': new FormControl(this.session.patient.profile.firstName, Validators.required),
      'middleName': new FormControl(this.session.patient.profile.middleName),
      'lastName': new FormControl(this.session.patient.profile.lastName, Validators.required),
      'birthdayFormGroup': this.birthdayFormGroup,
      'phoneNumber': new FormControl(
              this.session.patient.phoneNumber, 
              Validators.compose([
                  Validators.required, 
                  Validators.minLength(10),
                  Validators.maxLength(14), 
                  Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
                ]))
    });

    this.patientFormGroup.get('birthdayFormGroup').valueChanges.subscribe(data => this.onBirthdayValueChanged(data));
  }

  ngOnInit() {

  }
  
  dateValidator(control: FormGroup) {
    if (control.controls.month.value && control.controls.day.value && control.controls.year.value) {
      let value = control.controls.month.value + '/' + control.controls.day.value + '/' + control.controls.year.value;
      if (value && value.length > 0) {
        let birthday: string = value;
        let age: number;

        let regex, today, birthDate, month;
        regex = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/; //if no pattern provided
        if (!regex.test(birthday)) {
          return { 'invalidBirthday': true };
        }

        if (!age) {
          today = new Date();
          birthDate = new Date(birthday);
          age = today.getFullYear() - birthDate.getFullYear();
          month = today.getMonth() - birthDate.getMonth();
          if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
              age = age - 1;
          }
        }

        if (isNaN(age)) {
            age = -1;  //if age is invalid
        }      
        
        if (age === -1) {
          return { 'invalidBirthday': true };
        } else if (age < 18) {
          return { 'underage': true };
        }        
      }
    }
  }
  
  dateUnder18Validator(control: any) {
    if (control.month && control.day && control.year) {
      let value = control.month + '/' + control.day + '/' + control.year;
      if (value && value.length > 0) {
        let birthday: string = value;
        let age: number;

        let regex, today, birthDate, month;
        regex = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/; //if no pattern provided
        if (!regex.test(birthday)) {
          return true;
        }

        if (!age) {
          today = new Date();
          birthDate = new Date(birthday);
          age = today.getFullYear() - birthDate.getFullYear();
          month = today.getMonth() - birthDate.getMonth();
          if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
              age = age - 1;
          }
        }

        if (isNaN(age)) {
            age = -1;  //if age is invalid
        }      
        
        if (age === -1) {
          return true;
        }     
        
        if (age < 18) {
          return true;
        }

        return false;         
      }
    }

    return false;
  }

  onBirthdayValueChanged(value: any) {
    let validator = this.dateUnder18Validator(value);
  }
     
  get dateOfBirth() { return this.patientFormGroup.get('dateOfBirth'); }
  get email() { return this.patientFormGroup.get('email'); }
  get firstName() { return this.patientFormGroup.get('firstName'); }
  get gender() { return this.patientFormGroup.get('gender'); }
  get lastName() { return this.patientFormGroup.get('lastName'); }
  get middleName() { return this.patientFormGroup.get('middleName'); }
  get patientNotes() { return this.patientFormGroup.get('patientNotes'); }
  get phoneNumber() { return this.patientFormGroup.get('phoneNumber'); }

  continue() {
    this.session.patient.profile.dateOfBirth = new Date(this.birthdayFormGroup.controls.month.value + '/' + this.birthdayFormGroup.controls.day.value + '/' + this.birthdayFormGroup.controls.year.value);
    this.router.navigate(['/signup-address' ]);
  }
}